import React, { useEffect, useState } from "react";
import { Descriptions, Form, Modal, Table, notification, Tag } from "antd";
import { ExclamationCircleOutlined, CloseOutlined } from "@ant-design/icons";
import moment, { now } from 'moment';

import { useStateValue } from '../../../state';
import { FormatNumber } from "../../../ValueObjects";
import Data from "../../data";
import api from "../../../services/api";
import { InputPreco } from "../../../components";
import { isObjetoDiffVazio, formatarCpf } from "../../../services/funcoes";

export default function ModalEditarBoleto({ exibirModalEditarBoleto, fecharModalEditarBoleto }) {

    const [{ manutencao, parametrosEmpresa }, dispatch] = useStateValue();
    const [dadosNota, setDadosNota] = useState({});
    const [form] = Form.useForm();
    const [editandoParcelas, setEditandoParcelas] = useState(false);
    const [totalParcelas, setTotalParcelas] = useState(0);

    useEffect(() => {
        if (!!manutencao.dados && isObjetoDiffVazio(manutencao.dados)) {
            setTotalParcelas(manutencao.dados.length);
            setEditandoParcelas(true);
            setDadosNota(manutencao.dados[0]);
        }
    }, [manutencao.dados]);

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                form.resetFields();
                fecharModalEditarBoleto();
            }
        });
    };

    function onChangeValorParc(numeroParc, qtdTotParcelas, record) {
        let valorJaUtilizado = 0;
        let valorRestante = 0;
        let valorRestanteTot = 0;
        let valorParcelas = 0;
        let valorTotal = parseFloat(record.nfp_valor);
        let dados = form.getFieldValue();
        let boleto = manutencao.dados.find(item => item.bol_id === record.bol_id);
        boleto.bol_valor = parseFloat(dados[`bol_valor${numeroParc}`]);
        if (numeroParc === qtdTotParcelas) {
            return;
        }
        for (let i = 1; i <= numeroParc; i++) {
            valorJaUtilizado += parseFloat(dados[`bol_valor${i}`]);
        }
        valorRestante = valorTotal - valorJaUtilizado;
        valorParcelas = parseFloat((valorRestante / (qtdTotParcelas - numeroParc)).toFixed(2));
        for (let i = qtdTotParcelas; i > numeroParc; i--) {
            valorRestanteTot += valorParcelas;
            form.setFieldsValue({ [`bol_valor${i}`]: valorParcelas });
            manutencao.dados[i - 1].bol_valor = valorParcelas;
        }
        let valorSobra = valorTotal - (valorJaUtilizado + valorRestanteTot);
        form.setFieldsValue({ [`bol_valor${qtdTotParcelas}`]: parseFloat((valorParcelas + valorSobra).toFixed(2)) });
    };

    function ajustarDataParcelas(numeroParc, record) {
        let dataAtual = new Date(form.getFieldValue([`bol_datavencimento${numeroParc}`]).toDate());
        let dias = moment(dataAtual, 'YYYY-MM-DD').diff(moment(record.bol_dataemissao, 'YYYY-MM-DD'), 'days');
        let boleto = manutencao.dados.find(item => item.bol_id === record.bol_id);
        boleto.bol_datavencimento = dataAtual;
        if (dias > 5) {
            manutencao.dados
                .filter(item => item.prc_numeroparcela >= numeroParc)
                .forEach((parcela, index) => {
                    let dataVenc = moment(dataAtual).add(30 * index, 'days').toDate();
                    form.setFieldsValue({ [`bol_datavencimento${parcela.prc_numeroparcela}`]: moment(dataVenc) });
                    parcela.bol_datavencimento = dataVenc;
                });
        } else {
            notification.error({
                message: 'Data Inválida',
                description: 'A data de vencimento deve ser maior que a data de emissão em pelo menos 5 dias.',
            });
            form.setFieldsValue({ [`bol_datavencimento${numeroParc}`]: null });
        }
    }

    async function salvarParcelas() {
        let boleto = [];
        let dados = {};
        manutencao.dados.forEach(item => {

            boleto.unshift({
                bol_id: item.bol_id,
                bol_datavencimento: item.bol_datavencimento,
                bol_valor: item.bol_valor,
                ntf_id: item.ntf_id
            });
        });
        api.put(`Boleto/EditarBoleto`, boleto).then(
            res => {
                notification.success({ message: `Sucesso!`, description: `Boleto/Parcela alterada com Sucesso!` });
                fecharModalEditarBoleto();
            }
        ).catch(
            error => {
                console.log(error);
            }
        )
    };

    return (
        <Modal centered
            title={`Editar Boletos da Nota Fiscal N°: ${dadosNota.ntf_numero}`}
            open={exibirModalEditarBoleto}
            onCancel={onCloseModal}
            onOk={salvarParcelas}
            okText={
                <>
                    Salvar
                </>
            }
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            maskClosable={false}
        >
            <div>
                <div>
                    <Descriptions size="small">
                        <Descriptions.Item label="Nº Doc. Fiscal">
                            <b>{dadosNota.ntf_numero}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Emissão">
                            <b>{!!dadosNota.bol_dataemissao ? moment(dadosNota.bol_dataemissao).format('DD/MM/YYYY') : null}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Valor (R$)">
                            <b>{!!dadosNota.nfp_valor ? FormatNumber(dadosNota.nfp_valor, true) : null}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Destinatário">
                            <b>{dadosNota.pes_nome}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="CPF/CNPJ">
                            <b>{!!dadosNota.bol_cpfcnpjsacado ? formatarCpf(dadosNota.bol_cpfcnpjsacado) : ''}</b>
                        </Descriptions.Item>
                    </Descriptions>
                </div>
                <div className="tabela">
                    <Form layout="vertical" form={form} name="formParcelas"
                    >
                        <Table columns={[
                            {
                                title: 'Nota/Boletos',
                                render: ({ bol_numerodocumento }) => (
                                    <Tag color="processing">{bol_numerodocumento}</Tag>
                                ),
                            },
                            {
                                title: 'Data Pagamento',
                                render: ({ bol_datavencimento, prc_numeroparcela }, record) => (
                                    <div>
                                        {editandoParcelas ? <Data
                                            initialValue={bol_datavencimento}
                                            name={`bol_datavencimento${prc_numeroparcela}`}
                                            onBlur={() => { ajustarDataParcelas(prc_numeroparcela, record) }} /> : <b>{moment(bol_datavencimento).format('DD/MM/YYYY')}</b>
                                        }
                                    </div>
                                ),
                            },
                            {
                                title: 'Valor (R$)',
                                align: 'right',
                                render: ({ bol_valor, prc_numeroparcela }, record) => (
                                    <div>
                                        <InputPreco
                                            name={`bol_valor${prc_numeroparcela}`}
                                            initialValue={bol_valor}
                                            value={bol_valor}
                                            disabled={prc_numeroparcela === totalParcelas}
                                            onBlur={(e) => { onChangeValorParc(prc_numeroparcela, totalParcelas, record) }}


                                        />
                                    </div>
                                )
                            }
                        ]}
                            //dataSource={manutencao.dados} 
                            dataSource={(manutencao.dados || []).sort((a, b) => a.prc_numeroparcela - b.prc_numeroparcela)} // 🔹 Garantindo ordenação inicial
                            pagination={false}
                        />
                    </Form>
                </div>
            </div>
        </Modal>
    );
}